import { z } from 'zod';
export const MeetingPublicCommentStatus = {
    approved: 'approved',
    pending: 'pending',
    rejected: 'rejected',
};
export const meetingPublicCommentRejectSchema = z.object({
    rejectReason: z.string().trim().max(2000).nullish(),
});
